import { useNavigate, useLocation } from "react-router-dom";

import { IAdminRouteItem } from "../../../@types/AdminRoute";
import {
  MenuItemLink,
  ChildMenuItemLink,
  IconContainer,
  MenuItemText,
} from "./AdminSidebar.styles";

interface IAdminMenuItemProps extends IAdminRouteItem {
  isChild?: boolean;
}

export function AdminMenuItem({
  name,
  path,
  Icon,
  disabled,
  isChild = false,
}: IAdminMenuItemProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = location.pathname === path;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (disabled) return;
    navigate(path);
  };

  const LinkComponent = isChild ? ChildMenuItemLink : MenuItemLink;

  return (
    <LinkComponent
      href={path}
      onClick={handleClick}
      active={isActive}
      disabled={disabled}
    >
      {/* Sublist entries carry no icon (EN-5146 UI feedback): the group
          above them already has one, and a second column of small icons
          made the nested list busier without telling anyone anything. */}
      {Icon && !isChild && (
        <IconContainer>
          <Icon width="22px" height="22px" />
        </IconContainer>
      )}
      <MenuItemText>{name}</MenuItemText>
    </LinkComponent>
  );
}
